
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Requests_UpdateNewsletterConsentDto_$reflection, Requests_UpdateNewsletterConsentDto } from "./Shared/User.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "./CommunicationV2.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton, ofArray } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "./fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { obj_type } from "./fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Dialog } from "./Components/Dialog.js";
import { createObj } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextButton } from "./Components/Button.js";
import { withoutOnboardingTourQueryParams, isTenantsOnboardingTourPhase } from "./Common.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Navigation, TopNavigation } from "./Navigation.js";
import { map, defaultArg, unwrap } from "./fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ViewContainer } from "./Components/ViewContainer.js";
import { FloatingDialog } from "./Widgets/FloatingDialog.js";
import { toLocalTime, toString as toString_1 } from "./fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { TourGuideLocale, TourStep, TourGuide } from "./Components/TourGuide.js";

export function NewsletterConsentDialog(props) {
    let Title, elems;
    const t = useTranslation()[0];
    let patternInput_1;
    const initial = props.CurrentUser.NewsletterConsent == null;
    patternInput_1 = reactApi.useState(initial);
    const setIsOpen = patternInput_1[1];
    const saveConsent = (consent) => {
        const dto = new Requests_UpdateNewsletterConsentDto(consent);
        const body = toString(0, Auto_generateBoxedEncoder_437914C6(Requests_UpdateNewsletterConsentDto_$reflection(), undefined, undefined, undefined)(dto));
        let pr_2;
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_1;
            return ((url_1 = addPrefix("/api/users/newsletter-consent"), (refreshOn) => fetchWithDecoder(url_1, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [body])]), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), obj_type));
            }, refreshOn)))(true);
        }));
        pr_2 = (pr_1.then((_arg) => {
            setIsOpen(false);
        }));
        pr_2.then();
    };
    return createElement(Dialog, (Title = t("user.newsletter.dialog_title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4", "grid", "gap-2"])], (elems = [reactElement("p", {
            children: t("user.newsletter.dialog_description_1"),
        }), reactElement("p", {
            children: t("user.newsletter.dialog_description_2"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("user.newsletter.decline"),
            OnClick: () => {
                saveConsent(false);
            },
            TestId: "newsletter-consent-decline-button",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("user.newsletter.accept"),
            OnClick: () => {
                saveConsent(true);
            },
            TestId: "newsletter-consent-accept-button",
            Variant: "blueButton",
        })]),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsOpen(false);
        },
        Title: Title,
    }));
}

export function NavigationContainer(props) {
    let elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(true);
    const isDialogVisible = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const navigationMinimized = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setTenantsTourDismissed = patternInput_3[1];
    const showTenantsTour = isTenantsOnboardingTourPhase() && !patternInput_3[0];
    const clearTenantsOnboardingTourFromUrl = () => {
        RouterModule_nav(singleton("dashboard" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())), 1, 1);
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton_1("grid"), delay(() => append(navigationMinimized ? singleton_1("grid-cols-[5rem,2px,calc(100vw-5rem-2px)]") : singleton_1("grid-cols-[16rem,2px,calc(100vw-16rem-2px)]"), delay(() => append(singleton_1("print:flex"), delay(() => append(singleton_1("grid-rows-[4rem,calc(100vh-5rem)]"), delay(() => append(singleton_1("h-100"), delay(() => append(singleton_1("grow"), delay(() => (navigationMinimized ? singleton_1("relative") : empty()))))))))))))))))], (elems_2 = toList(delay(() => append(singleton_1(createElement(TopNavigation, {
        AccountSettings: props.AccountSettings,
        Configuration: props.Configuration,
        CurrentUser: props.CurrentUser,
        OnLogout: props.OnLogout,
        SubTestId: unwrap(props.SubTestId),
        SubTitle: unwrap(props.SubTitle),
        TestId: props.TestId,
        Title: props.Title,
        ToggleNavigationMinimized: () => {
            patternInput_2[1](!navigationMinimized);
        },
        UserData: props.UserData,
        Username: props.CurrentUser.Name,
    })), delay(() => append(navigationMinimized ? singleton_1(reactElement("div", {
        className: join(" ", ["row-start-1", "row-span-2", "col-start-1", "bg-white"]),
    })) : empty(), delay(() => append(singleton_1(createElement(Navigation, {
        AccountSettings: props.AccountSettings,
        CurrentUrl: props.CurrentUrl,
        CurrentUser: props.CurrentUser,
        CustomerConfiguration: props.Configuration,
        IsInTestphase: props.IsInTestphase,
        NavigationMinimized: navigationMinimized,
        UserData: props.UserData,
    })), delay(() => append(singleton_1(reactElement("div", {
        className: join(" ", ["row-start-1", "row-span-2", "min-w-[2px]", "bg-divider"]),
    })), delay(() => {
        let elems_1;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["row-start-2", "col-start-3", "grow", "flex", "flex-col", "bg-background", "relative", "w-full"])], (elems_1 = toList(delay(() => append(singleton_1(createElement(ViewContainer, {
            Children: props.SubView,
        })), delay(() => {
            let matchValue, elems, Text$;
            return append(isDialogVisible ? ((matchValue = props.AccountSettings.AccountState, (matchValue === "testPeriodEnded") ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["w-248", "bottom-10", "left-[50%]", "translate-x-[-50%]", "bg-transpatent", "grid-cols-2", "absolute"])], (elems = [createElement(FloatingDialog, (Text$ = t("dashboard.testphasemodal"), {
                Date: defaultArg(map((accountEndDate) => toString_1(toLocalTime(accountEndDate), "dd.MM.yyyy"), props.AccountSettings.AccountEndDate), ""),
                OnCancelClick: () => {
                    patternInput_1[1](!isDialogVisible);
                },
                OnClick: () => {
                    RouterModule_nav(ofArray(["customer", "wizard"]), 1, 1);
                },
                Text: Text$,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : ((matchValue === "testPeriodActive") ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["w-248", "bottom-10", "left-[50%]", "translate-x-[-50%]", "bg-transpatent", "grid-cols-2", "absolute"])], (elems = [createElement(FloatingDialog, (Text$ = t("dashboard.testphasemodal"), {
                Date: defaultArg(map((accountEndDate) => toString_1(toLocalTime(accountEndDate), "dd.MM.yyyy"), props.AccountSettings.AccountEndDate), ""),
                OnCancelClick: () => {
                    patternInput_1[1](!isDialogVisible);
                },
                OnClick: () => {
                    RouterModule_nav(ofArray(["customer", "wizard"]), 1, 1);
                },
                Text: Text$,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : (empty())))) : empty(), delay(() => singleton_1(createElement(NewsletterConsentDialog, {
                CurrentUser: props.CurrentUser,
            }))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let Steps;
            return showTenantsTour ? singleton_1(createElement(TourGuide, (Steps = singleton(new TourStep("[data-test-id=\'top-navigation-user-menu\']", t("onboarding.tour.tenants_user_menu_title"), reactElement("div", {
                children: t("onboarding.tour.tenants_user_menu_content"),
            }), "bottom", true)), {
                IsRunning: true,
                Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                OnFinish: () => {
                    setTenantsTourDismissed(true);
                    clearTenantsOnboardingTourFromUrl();
                },
                OnSkip: () => {
                    setTenantsTourDismissed(true);
                    clearTenantsOnboardingTourFromUrl();
                },
                ScrollFirstStep: true,
                Steps: Steps,
            }))) : empty();
        }));
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

